import './App.css';
import { BrowserRouter , Routes, Route} from 'react-router-dom';
import Barkingdog from './Barkingdog';
import FirstScene from './FirstScene';
import Viewer_ar from './Viewer_ar';
function App() {
  return (
    <div className="App">
      {/* <FirstScene /> */}
      <BrowserRouter>
        <Routes> 

          <Route path="/" element={<FirstScene />} />
          <Route path="ar" element={<Viewer_ar />} />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
